import { render, staticRenderFns } from "./footer_login.vue?vue&type=template&id=2eda75c3&scoped=true"
import script from "./footer_login.vue?vue&type=script&lang=js"
export * from "./footer_login.vue?vue&type=script&lang=js"
import style0 from "./footer_login.vue?vue&type=style&index=0&id=2eda75c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eda75c3",
  null
  
)

export default component.exports